import React from 'react';
import { ListSearch } from '@bedrock/icons-react';
import type { TriggerComponent } from '../types';

/**
 * Div 触发器变体。
 * 还原 ProjectCodeSelect/index.tsx 的 div + 搜索图标模式：
 * 纯 div 显示 placeholder 或 value 文本 + 右侧搜索图标。
 */
export const DivVariant: TriggerComponent = ({
  displayValue,
  onClick,
  disabled,
  placeholder = '请选择',
}) => {
  return (
    <div
      className={`input-trigger-div inline-flex items-center justify-between w-full
        border border-color-2 rounded px-3 py-1.5 text-sm gap-2
        ${disabled
          ? 'bg-3 text-color-3 cursor-not-allowed'
          : 'bg-white cursor-pointer hover:border-primary-6 transition-colors'
        }`}
      onClick={disabled ? undefined : onClick}
    >
      <span className={displayValue ? 'text-color-1' : 'text-color-3'}>
        {displayValue || placeholder}
      </span>
      <ListSearch className="text-color-3 flex-shrink-0" />
    </div>
  );
};
